/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import { createSampleDeviceTypes } from '../services/AnalyticsEngineAPI';
import { createV2DeviceTypeAPI } from '../services/V2DeviceTypeAPI';

import { Version } from 'CommonTypes';

export const CREATE_DEVICE_TYPE = 'CREATE_DEVICE_TYPE';
export const CREATE_DEVICE_TYPE_FAILURE = 'CREATE_DEVICE_TYPE_FAILURE';
export const CREATE_DEVICE_TYPE_SUCCESS = 'CREATE_DEVICE_TYPE_SUCCESS';

// action
const startCreateDeviceType = () => ({
  type: CREATE_DEVICE_TYPE,
});

// action
const createDeviceTypeFailure = error => ({
  type: CREATE_DEVICE_TYPE_FAILURE,
  payload: error,
});

// action
const createDeviceTypeSuccess = storeData => ({
  type: CREATE_DEVICE_TYPE_SUCCESS,
  payload: storeData,
});

// execute the given function
export const createDeviceType =
  (catalogFunction, params) =>
  (dispatch, getState, { dataCache }) => {
    dispatch(startCreateDeviceType());

    // V2 device type function
    if (catalogFunction.version === Version.V2) {
      const userEmailId = dataCache.get('currentUser')?.id;
      return createV2DeviceTypeAPI(params, userEmailId)
        .then(responseJson => {
          dispatch(createDeviceTypeSuccess(responseJson || {}));
          return responseJson;
        })
        .catch(error => {
          dispatch(createDeviceTypeFailure(error));
          throw error;
        });
    }
    // V1 device type function
    return createSampleDeviceTypes(catalogFunction.name, params)
      .then(responseJson => {
        dispatch(createDeviceTypeSuccess(responseJson || {}));
        return responseJson;
      })
      .catch(error => {
        dispatch(createDeviceTypeFailure(error));
        throw error;
      });
  };
